import type { UseMutationResult } from 'react-query';
import { useMutation } from 'react-query';

import type { IApiClientAuthorization } from '~/lib/api/ApiClient';
import type { IAppRegion } from '~/lib/appSettings';
import type { IApiLogInRequestBody } from '../AuthApi.types';
import { generateSessionId, useAuth } from '~/lib/auth';

export type IUseLogInMutationValues = {
  region: IAppRegion;
  body: IApiLogInRequestBody;
};

export const useLogInMutation = (): UseMutationResult<
  IApiClientAuthorization,
  unknown,
  IUseLogInMutationValues
> => {
  const auth = useAuth();

  return useMutation({
    mutationFn: (values: IUseLogInMutationValues) =>
      auth.logInWithCredentials(values.region, values.body),
    onSuccess: async (data, values) => {
      const sessionId = generateSessionId(values.region, data.user._id);
      await auth.setAuthorization({
        sessionId,
        region: values.region,
        user: data.user,
        authToken: data.authToken,
      });
    },
  });
};
